import { Component, Input } from '@angular/core';

import { AppFeatureExtensions, JobFilterExtensions } from '@app/app-feature-extensions.config';

import { ACTIVE_JOB_STATUS, INACTIVE_JOB_STATUS, JobStatusEnum } from '../models/job-statuses';

@Component({
  selector: 'mojo-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent {
  @Input() status: string;
  @Input() statusFilterType: JobFilterExtensions = AppFeatureExtensions.JOB_STATUSES_ALL;

  get mappedStatus(): string {
    if (this.statusFilterType === AppFeatureExtensions.JOB_STATUSES_BASIC) {
      return this.status === JobStatusEnum.Canceled ? INACTIVE_JOB_STATUS : ACTIVE_JOB_STATUS;
    } else {
      return this.status;
    }
  }

  get isActive(): boolean {
    const activeToken =  this.statusFilterType === AppFeatureExtensions.JOB_STATUSES_BASIC ?
      ACTIVE_JOB_STATUS :
      JobStatusEnum.Progress;
    return this.mappedStatus === activeToken;
  }
}
